<div class="d-flex gap-2 text-warning">
  @for (_ of fullArray; track trackByIndex($index)) {
    <i class="fas fa-star"></i>
  }
  @if (halfStar) {
    <i class="fas fa-star-half-alt"></i>
  }
  @for (_ of emptyArray; track trackByIndex($index)) {
    <i class="far fa-star"></i>
  }
</div>
